"use strict"; // Passive event listeners

jQuery.event.special.touchstart = {
  setup: function (_, ns, handle) {
    this.addEventListener("touchstart", handle, {
      passive: !ns.includes("noPreventDefault")
    });
  }
};
jQuery.event.special.touchmove = {
  setup: function (_, ns, handle) {
    this.addEventListener("touchmove", handle, {
      passive: !ns.includes("noPreventDefault")
    });
  }
}; //========== remove trasitions ==============

document.addEventListener("DOMContentLoaded", function () {
  let node = document.querySelector(".o-preload-transitions");

  if (node) {
    node.classList.remove("o-preload-transitions");
  }
}); //========== add js-enabled class to body if js is enabled - used to determine if animations are shown ==============

document.addEventListener('DOMContentLoaded', function () {
  document.body.classList.add('js-enabled');
}); //========== Has scrolled ==============

const hasScrolled = () => {
  const nav = document.querySelector(".js-primary-nav");

  if (document.body.scrollTop >= 50 || document.documentElement.scrollTop >= 50) {
    nav.classList.add("has-scrolled-header");
  } else {
    nav.classList.remove("has-scrolled-header");
  }
};

hasScrolled(); //========== Window scroll==============

window.addEventListener("scroll", () => {
  throttle(handleScrollAnimation, hasScrolled, 250);
}); //========== Scroll Throttle timer==============

let throttleTimer = false;

const throttle = (callbackAnimate, callbackScrolled, time) => {
  if (throttleTimer) return;
  throttleTimer = true;
  setTimeout(() => {
    callbackAnimate();
    callbackScrolled();
    throttleTimer = false;
  }, time);
}; //========== Mobile menu ==============


const mobileButton = document.querySelector(".c-burger__btn");
const mobileNav = document.querySelector(".js-primary-nav-toggle");
const mobileMenu = document.querySelector(".menu-header-container");
const nav = document.querySelector(".js-primary-nav");
const body = document.querySelector("body");
mobileNav.addEventListener("click", function () {
  mobileButton.classList.toggle("is-active");
  mobileNav.classList.toggle("is-active");
  mobileMenu.classList.toggle("is-active");
  nav.classList.toggle("is-active");
  body.classList.toggle("is-open");
}); //========== Cookie settings ==============

const cookieSettings = document.querySelector(".cookie-settings a");
cookieSettings.addEventListener("click", function (e) {
  e.preventDefault();
  CassieWidgetLoader.Widget.showModal();
});

if ($(window).width() > 768) {
  // Split Feature Hover effect
  $('body').find('.c-m-split-feature__content').on('mouseenter', function () {
    $(this).find('.c-m-split-feature__reveal').slideDown();
  });
  $('body').find('.c-m-split-feature__content').on('mouseleave', function () {
    $(this).find('.c-m-split-feature__reveal').slideUp();
  });
}

const accordion = document.querySelectorAll(".c-m-accordion ul.c-m-accordion__wrapper > li > a");

const toggleAccordion = e => {
  e.preventDefault();
  e.currentTarget.classList.toggle("is-active");
};

accordion.forEach(e => {
  e.addEventListener("click", toggleAccordion);
});
const scrollElements = document.querySelectorAll(".is-to-fade");

const elementInView = function (el) {
  let offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  const elementTop = el.getBoundingClientRect().top;
  return elementTop <= (window.innerHeight || document.documentElement.clientHeight) / offset;
};

const elementOutofView = el => {
  const elementTop = el.getBoundingClientRect().top;
  return elementTop > (window.innerHeight || document.documentElement.clientHeight);
};

const displayScrollElement = element => {
  element.classList.add("has-scrolled");
};

const hideScrollElement = element => {
  element.classList.remove("has-scrolled");
};

const handleScrollAnimation = () => {
  scrollElements.forEach(el => {
    if (elementInView(el, 1)) {
      displayScrollElement(el);
    } else if (elementOutofView(el)) {
      hideScrollElement(el);
    }
  });
};

handleScrollAnimation(); // Dependencies: jQuery
// Description: This script will apply the background color of the first section to the breadcrumbs and determine the text color based on the background luminance.

if ($('.c-breadcrumbs').length && $('section:first section:first').length) {
  // Get the background color of the first section
  var firstSectionBgColor = $('section:first section:first').css('background-color'); // Apply the background color to .c-breadcrumbs

  $('.c-breadcrumbs').css('background-color', firstSectionBgColor); // Determine text color based on background luminance

  var textColor = getTextColor(firstSectionBgColor);

  if (textColor == 'black') {
    textColor = "#262623";
  }

  $('.c-breadcrumbs').css('color', textColor);
} // Ultra simple maths so low compute power, doesnt affect pagescore and its a nice touch


function getTextColor(backgroundColor) {
  // Convert the background color to an RGB array
  var rgb = backgroundColor.match(/\d+/g); // Calculate the luminance using the formula: 0.299*R + 0.587*G + 0.114*B

  var luminance = 0.299 * rgb[0] + 0.587 * rgb[1] + 0.114 * rgb[2]; // Choose text color based on luminance threshold (adjust as needed)

  return luminance > 128 ? 'black' : 'white';
}

document.addEventListener('DOMContentLoaded', function () {
  if (document.querySelector('.js-itp-calculator-form')) {
    // Handle change events for total sessions input
    const totalSessionsInput = document.getElementById('number_of_visitors');
    let monthlySessionsText = document.querySelector('.js-itp-monthly-sessions-text');

    if (totalSessionsInput) {
      totalSessionsInput.addEventListener('input', function () {
        let monthlySessionsFormatted = formatNumberWithCommas(this);
        monthlySessionsText.textContent = monthlySessionsFormatted;
      });
    } // Handle change events for mobile/desktop visitors inputs


    const mobileInput = document.getElementById('visitors_device_mobile');
    const desktopInput = document.getElementById('visitors_device_desktop');
    const mobileTrafficText = document.querySelector('.js-itp-mobile-traffic-text');
    const desktopTrafficText = document.querySelector('.js-itp-desktop-traffic-text');

    if (mobileInput && desktopInput) {
      mobileInput.addEventListener('input', function () {
        allowOnlyNumbers(mobileInput, 100, 3);
        allowOnlyNumbers(desktopInput, 100, 3);
        updateDependentInput(this, desktopInput);
        updateResultsText(this, mobileTrafficText);
        updateResultsText(desktopInput, desktopTrafficText);
      });
      desktopInput.addEventListener('input', function () {
        allowOnlyNumbers(mobileInput, 100, 3);
        allowOnlyNumbers(desktopInput, 100, 3);
        updateDependentInput(this, mobileInput);
        updateResultsText(this, desktopTrafficText);
        updateResultsText(mobileInput, mobileTrafficText);
      });
    } // Handle change events for new/returning users inputs


    const newUsersInput = document.getElementById('new_visitors');
    const returningUsersInput = document.getElementById('returning_visitors');

    if (newUsersInput && returningUsersInput) {
      newUsersInput.addEventListener('input', function () {
        allowOnlyNumbers(newUsersInput, 100, 3);
        allowOnlyNumbers(returningUsersInput, 100, 3);
        updateDependentInput(this, returningUsersInput);
        updateResultsText(this, newUsersInput);
        updateResultsText(returningUsersInput, returningUsersInput);
      });
      returningUsersInput.addEventListener('input', function () {
        allowOnlyNumbers(newUsersInput, 100, 3);
        allowOnlyNumbers(returningUsersInput, 100, 3);
        updateDependentInput(this, newUsersInput);
        updateResultsText(this, returningUsersInput);
        updateResultsText(newUsersInput, newUsersInput);
      });
    } // Handle change events for monthly revenue input


    const monthlyRevenueInput = document.getElementById('monthly_revenue');

    if (monthlyRevenueInput) {
      monthlyRevenueInput.addEventListener('input', function () {
        updateRevenueInputs(this);
      });
    } // Handle change events for annual revenue input


    const annualRevenueInput = document.getElementById('annual_revenue');

    if (annualRevenueInput) {
      annualRevenueInput.addEventListener('input', function () {
        updateRevenueInputs(this);
      });
    }

    const inputFields = document.querySelectorAll('input[required]');
    inputFields.forEach(inputField => {
      inputField.addEventListener('input', function () {
        validateInput(inputField);
      });
      inputField.addEventListener('blur', function () {
        validateInput(inputField);
      });
    }); // ITP calculations

    const itpCalculatorForm = document.querySelector('.js-itp-calculator-form');
    const itpCalculatorButton = document.querySelector('.js-itp-calculator-submit-button');
    const itpLoadingScreen = document.querySelector('.js-calculating-loading-screen');
    const itpCalculatorResults = document.querySelector('.js-itp-calculator-results');
    const itpFormDownload = document.querySelector('.js-itp-calculator-download-form');
    let itpCalculatorMisattributedFigure = document.querySelector('.js-misattributed-sessions-number-text');
    let itpCalculatorTotalSessions = document.querySelectorAll('.js-total-sessions-number');
    let itpCalculatorMisattrubtedPercentage = document.querySelector('.js-misattributed-sessions-percentage');
    let itpCalculatorNewUsersText = document.querySelector('.js-new-users-text-amount');
    let itpCalculatorReturningUserPercentage = document.querySelector('.js-returning-visitors-percentage-text');
    let itpCalculatorTrackingPreventionText = document.querySelector('.js-tracking-prevention-number-text');
    let misattributedRevenueText = document.querySelector('.js-misattributed-revenue-figure');
    let monthlyRevenueText = document.querySelector('.js-monthly-revenue-figure');
    let misattributedRevenuePercentageText = document.querySelector('.js-misattributed-revenue-percentage');

    if (itpCalculatorButton) {
      itpCalculatorButton.addEventListener('click', function (e) {
        // Validate input fields before proceeding with calculations
        if (!validateAllInputs('js-itp-calculator-form')) {
          // Prevent default behavior if validation fails
          return;
        } // Make sure all instances of chartjs are destroyed


        destroyAllCharts();
        e.preventDefault();
        let totalSessionsNumber = getNumberWithoutCommas(totalSessionsInput);
        const totalSessions = parseInt(totalSessionsInput.value) || 0;
        const newUsersPercentage = parseInt(newUsersInput.value) || 0;
        const returningUsersPercentage = parseInt(returningUsersInput.value) || 0;
        let newUsersFigure = Math.round(totalSessionsNumber * (newUsersPercentage / 100));
        let returningUsersFigure = totalSessionsNumber * (returningUsersPercentage / 100);
        returningUsersFigure = returningUsersFigure.toFixed();
        let monthlyRevenue = document.querySelector('#monthly_revenue');
        let monthlyRevenueFigure = parseInt(monthlyRevenue.value) || 0;
        let monthlyRevenueNumber = getNumberWithoutCommas(monthlyRevenueInput); // Dynamic text figures

        let totalMisattributions = 0;
        let totalMisattributionsPercentage = 0; // Show the loading screen

        if (itpLoadingScreen) itpLoadingScreen.style.display = 'grid'; // Scroll to the loading screen immediately upon button click

        if (itpLoadingScreen) itpLoadingScreen.scrollIntoView({
          behavior: 'smooth'
        }); // Delay for 3 seconds before scrolling to results

        setTimeout(function () {
          // Scroll to the results section with offset for sticky header
          if (itpCalculatorResults) {
            var headerHeight = $('.js-header').outerHeight();
            $(itpCalculatorResults).addClass('active');
            $(itpFormDownload).addClass('active');
            $('html, body').animate({
              scrollTop: $(itpCalculatorResults).offset().top - headerHeight
            }, 1000);
          }
        }, 3000); // 3 seconds
        // Hide loading screen after 5 seconds

        setTimeout(function () {
          // Hide the loading screen
          $(itpLoadingScreen).hide();
        }, 5000); // Perform the calculation

        const enhancedPrivacyDesktop = calculateEnhancedPrivacyDesktop(totalSessionsNumber, desktopInput);
        const enhancedPrivacyMobile = calculateEnhancedPrivacyMobile(totalSessionsNumber, mobileInput); // Total Misattributions = Enhanced Privacy on Desktop + Enhanced Privacy on Mobile

        totalMisattributions = enhancedPrivacyDesktop + enhancedPrivacyMobile; // Total Misattributions Percentage = Total Misattributions / Total Session * 100

        totalMisattributionsPercentage = totalMisattributions / totalSessionsNumber * 100;
        itpCalculatorMisattrubtedPercentage.textContent = totalMisattributionsPercentage.toFixed(1) + '%';
        let misattributedPeople = document.querySelector('.js-misattributed-figures');
        let peopleFigures = document.querySelectorAll('.js-person-figure');
        let peopleHighlighted = Math.round(totalMisattributionsPercentage / 100) * 4;

        for (var i = 0; i <= peopleHighlighted; i++) {
          peopleFigures[i].classList.add('highlight');
        }

        let totalSessionsNumberFormatted = formatNumberWithCommas(totalSessionsInput); // Set Total Sessions number

        itpCalculatorTotalSessions.forEach(element => element.textContent = totalSessionsNumberFormatted); // Set Total Misattributed Sessions number

        itpCalculatorMisattributedFigure.textContent = totalMisattributions.toLocaleString('en-GB');
        itpCalculatorNewUsersText.textContent = newUsersFigure.toLocaleString('en-GB');
        itpCalculatorReturningUserPercentage.textContent = returningUsersPercentage.toFixed() + '%';
        createAttributedSessionsPieChart('js-misattributed-sessions-graph', totalMisattributions, totalSessionsNumber);
        createNewReturningUsersDoughnutChart('js-new-returning-users-graph', returningUsersFigure, newUsersFigure);
        const returningUsersWithTrackingPrevention = calculateReturningUsersWithTrackingPrevention(totalSessionsNumber, newUsersPercentage);
        itpCalculatorTrackingPreventionText.textContent = returningUsersWithTrackingPrevention.toLocaleString('en-GB');
        let newUsersWithTracking = newUsersFigure - returningUsersWithTrackingPrevention;
        createReturningUsersWithTrackingPreventionDoughnutChart('js-new-returning-with-tracking-prevention-users-graph', returningUsersWithTrackingPrevention, returningUsersFigure, newUsersWithTracking);
        let revenueBox = document.querySelector('.js-revenue-reporting-results-box');

        if (monthlyRevenue.value.trim() !== '') {
          revenueBox.style.display = 'block';
          let misattributedRevenue = monthlyRevenueFigure * (totalMisattributionsPercentage / 100);
          let misattributedRevenueFormatted = formatCurrency(misattributedRevenue);
          misattributedRevenueText.textContent = misattributedRevenueFormatted;
          monthlyRevenue = formatCurrency(monthlyRevenueFigure);
          monthlyRevenueText.textContent = monthlyRevenue;
          misattributedRevenuePercentageText.textContent = totalMisattributionsPercentage.toFixed() + '%';
          misattributedRevenue = misattributedRevenue.toFixed();
          createmisattrobutedRevenueSessionsPieChart('js-misattributed-revenue-graph', monthlyRevenueFigure, misattributedRevenue);
        } else {
          revenueBox.style.display = 'none';
        }
      });
    }
  }

  ;
}); // Function to calculate desktop sessions based on total sessions and desktop percentage

function calculateDesktopSessions(totalSessions, desktopInput) {
  const desktopPercentage = parseInt(desktopInput.value) || 0;
  const desktopSessions = totalSessions * desktopPercentage / 100;
  return desktopSessions;
} // Function to calculate mobile sessions based on total sessions and desktop percentage


function calculateMobileSessions(totalSessions, mobileInput) {
  const mobilePercentage = parseInt(mobileInput.value) || 0;
  const mobileSessions = totalSessions * mobilePercentage / 100;
  return mobileSessions;
} // Function to calculate enhanced privacy on desktop based on total sessions and desktop input


function calculateEnhancedPrivacyDesktop(totalSessions, desktopInput) {
  const browserMarketShare = JSON.parse(WP.browser_market_share);
  let desktopSessions = calculateDesktopSessions(totalSessions, desktopInput);
  let enhancedPrivacyOnDesktop = 0;
  browserMarketShare.forEach(browserArray => {
    browserArray.forEach(browser => {
      const marketShare = parseInt(browser.market_share) || 0;
      const browserSessionsPercentage = marketShare / 100;

      if (browser.full_enhanced_privacy) {
        // Add market share for browsers with full enhanced privacy
        enhancedPrivacyOnDesktop += browserSessionsPercentage;
      } else if (browser.partial_enhanced_privacy) {
        // Add 0.01 times market share for browsers with partial enhanced privacy
        enhancedPrivacyOnDesktop += browserSessionsPercentage * 0.01;
      }
    });
  });
  enhancedPrivacyOnDesktop = desktopSessions * enhancedPrivacyOnDesktop; // Return the calculated enhanced privacy value

  return Math.round(enhancedPrivacyOnDesktop);
} // Function to calculate enhanced privacy on mobile based on total sessions and mobile input


function calculateEnhancedPrivacyMobile(totalSessions, mobileInput) {
  const mobileOsMarketShare = JSON.parse(WP.os_market_share);
  let mobileSessions = calculateMobileSessions(totalSessions, mobileInput);
  let enhancedPrivacyOnMobile = 0;
  mobileOsMarketShare.forEach(mobileOsArray => {
    mobileOsArray.forEach(mobileOs => {
      const marketShare = parseInt(mobileOs.market_share) || 0;
      const browserSessionsPercentage = marketShare / 100;

      if (mobileOs.full_enhanced_privacy) {
        // Add market share for browsers with full enhanced privacy
        enhancedPrivacyOnMobile += browserSessionsPercentage;
      } else if (mobileOs.partial_enhanced_privacy) {
        // Add 0.01 times market share for browsers with partial enhanced privacy
        enhancedPrivacyOnMobile += browserSessionsPercentage * 0.01;
      }
    });
  });
  enhancedPrivacyOnMobile = mobileSessions * enhancedPrivacyOnMobile; // Return the calculated enhanced privacy value

  return Math.round(enhancedPrivacyOnMobile);
} // Function to calculate potential returning users that have blocked tracking


function calculateReturningUsersWithTrackingPrevention(totalSessions, newUsersPercentage) {
  const browserMarketShare = JSON.parse(WP.browser_market_share);
  let newUsersFigure = Math.round(totalSessions * (newUsersPercentage / 100));
  let returningUsersWithTrackingPrevention = 0;
  browserMarketShare.forEach(browserArray => {
    browserArray.forEach(browser => {
      const marketShare = parseInt(browser.market_share) || 0;
      const browserSessionsPercentage = marketShare / 100;

      if (browser.full_enhanced_privacy) {
        returningUsersWithTrackingPrevention += browserSessionsPercentage;
      } else if (browser.partial_enhanced_privacy) {
        returningUsersWithTrackingPrevention += browserSessionsPercentage * 0.01;
      }
    });
  });
  returningUsersWithTrackingPrevention = newUsersFigure * returningUsersWithTrackingPrevention; // Return the calculated enhanced privacy value

  return Math.round(returningUsersWithTrackingPrevention);
}

function createAttributedSessionsPieChart(graphLocationClass, totalMisattributions, totalSessionsNumber) {
  let correctlyAttributedSessions = totalSessionsNumber - totalMisattributions;
  const graph = document.getElementById(graphLocationClass);
  new Chart(graph, {
    type: 'pie',
    data: {
      labels: ['Remaining sessions', 'Misattributed sessions'],
      datasets: [{
        data: [correctlyAttributedSessions, totalMisattributions],
        borderWidth: 0,
        backgroundColor: ['rgb(138, 225, 224)', 'rgb(255, 57, 84)'],
        hoverOffset: 2
      }]
    },
    options: {
      plugins: {
        legend: {
          display: false
        }
      }
    }
  });
}

function createNewReturningUsersDoughnutChart(graphLocationClass, returningUsersFigure, newUsersFigure) {
  const graph = document.getElementById(graphLocationClass);
  new Chart(graph, {
    type: 'doughnut',
    data: {
      labels: ['Returning users', 'New users'],
      datasets: [{
        data: [returningUsersFigure, newUsersFigure],
        borderWidth: 0,
        backgroundColor: ['rgb(255, 201, 38)', 'rgb(255, 57, 84)'],
        hoverOffset: 2
      }]
    },
    options: {
      plugins: {
        legend: {
          display: false
        }
      }
    }
  });
}

function createReturningUsersWithTrackingPreventionDoughnutChart(graphLocationClass, mayBeReturningFigure, returningUsersFigure, newUsersFigure) {
  const graph = document.getElementById(graphLocationClass);
  new Chart(graph, {
    type: 'doughnut',
    data: {
      labels: ['Might be returning', 'Returning users', 'New users'],
      datasets: [{
        data: [mayBeReturningFigure, returningUsersFigure, newUsersFigure],
        borderWidth: 0,
        backgroundColor: ['rgb(80, 224, 220)', 'rgb(255, 201, 38)', 'rgb(255, 57, 84)'],
        hoverOffset: 3
      }]
    },
    options: {
      plugins: {
        legend: {
          display: false
        }
      }
    }
  });
}

function createmisattrobutedRevenueSessionsPieChart(graphLocationClass, totalRevenue, misattributedRevenue) {
  let remainingRevenue = totalRevenue - misattributedRevenue;
  const graph = document.getElementById(graphLocationClass);
  new Chart(graph, {
    type: 'pie',
    data: {
      labels: ['Remaining revenue', 'Misattributed revenue'],
      datasets: [{
        data: [remainingRevenue, misattributedRevenue],
        borderWidth: 0,
        backgroundColor: ['rgb(255, 201, 38)', 'rgb(255, 57, 84)'],
        hoverOffset: 2
      }]
    },
    options: {
      plugins: {
        legend: {
          display: false
        }
      }
    }
  });
} // Function to destroy all Chart.js charts


function destroyAllCharts() {
  // Find all canvas elements with the class 'chartjs-chart'
  const chartElements = document.querySelectorAll('canvas.chartjs-chart'); // Iterate over each canvas element

  chartElements.forEach(canvas => {
    // Get the associated Chart.js instance
    const chartInstance = Chart.getChart(canvas); // If a Chart.js instance exists, destroy it

    if (chartInstance) {
      chartInstance.destroy();
    }
  });
}

function formatCurrency(number) {
  // Round to the nearest whole number
  let roundedNumber = Math.round(number); // Convert to currency format with commas

  let formattedCurrency = roundedNumber.toLocaleString('en-GB', {
    style: 'currency',
    currency: 'GBP',
    minimumFractionDigits: 0
  });
  return formattedCurrency;
}

function allowOnlyNumbers(inputElement) {
  let maxValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
  let maxDigits = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 3;
  inputElement.addEventListener('keydown', function (event) {
    // Allow: backspace, delete, tab, escape, enter
    if ([46, 8, 9, 27, 13].indexOf(event.keyCode) !== -1 || // Allow: Ctrl+A/Ctrl+C/Ctrl+V/Ctrl+X
    event.keyCode === 65 && (event.ctrlKey === true || event.metaKey === true) || event.keyCode === 67 && (event.ctrlKey === true || event.metaKey === true) || event.keyCode === 86 && (event.ctrlKey === true || event.metaKey === true) || event.keyCode === 88 && (event.ctrlKey === true || event.metaKey === true) || // Allow: home, end, left, right
    event.keyCode >= 35 && event.keyCode <= 39) {
      // let it happen, don't do anything
      return;
    } // Prevent negative sign


    if (event.keyCode === 189 || event.keyCode === 109) {
      // Key codes for '-' (hyphen/minus)
      event.preventDefault();
      return;
    } // Ensure that it is a number and stop the keypress


    const currentValue = parseFloat(inputElement.value + event.key);

    if (isNaN(currentValue) || currentValue > maxValue || inputElement.value.length >= maxDigits) {
      event.preventDefault();
    }
  });
} // Function to update the other input based on a changed input value


function updateDependentInput(changedInput, dependentInput) {
  const changedValue = parseInt(changedInput.value) || 0;
  const dependentValue = 100 - changedValue;
  dependentInput.value = dependentValue; // Ensure the total is 100%
} // Function to update monthly and annual revenue based on user input


function updateRevenueInputs(inputField) {
  const monthlyRevenueInput = document.getElementById('monthly_revenue');
  const annualRevenueInput = document.getElementById('annual_revenue');
  let monthlyRevenue, annualRevenue;

  if (inputField === monthlyRevenueInput) {
    monthlyRevenue = parseFloat(inputField.value) || 0;
    annualRevenue = Math.round(monthlyRevenue * 12);
    annualRevenueInput.value = annualRevenue;
  } else if (inputField === annualRevenueInput) {
    annualRevenue = parseFloat(inputField.value) || 0;
    monthlyRevenue = Math.round(annualRevenue / 12);
    monthlyRevenueInput.value = monthlyRevenue;
  }
} // Function to update text content based on input value


function updateResultsText(inputElement, textElement) {
  let valueToDisplay = parseInt(inputElement.value) || 0;
  valueToDisplay += '%'; // Append percentage symbol for desktop/mobile traffic text elements

  textElement.textContent = valueToDisplay;
} // Function to validate input fields


function validateInput(inputField) {
  if (!inputField.value.trim()) {
    // Mark field as invalid
    inputField.classList.add('invalid');
    return false;
  } else {
    // Mark field as valid
    inputField.classList.remove('invalid');
    return true;
  }
} // Function to validate all required input fields


function validateAllInputs(formClass) {
  let isValid = true;
  const inputFields = document.querySelectorAll(`.${formClass} input[required]`);
  inputFields.forEach(inputField => {
    if (!validateInput(inputField)) {
      isValid = false;
    }
  });
  return isValid;
}

function formatNumberWithCommas(input) {
  let value = input.value.replace(/\D/g, ''); // Remove non-numeric characters

  return input.value = value.replace(/\B(?=(\d{3})+(?!\d))/g, ','); // Add commas
}

function getNumberWithoutCommas(input) {
  return input.value.replace(/,/g, '');
} // prevent user from scrolling within number inputs


$(document).on("wheel", "input[type=number]", function (e) {
  $(this).blur();
});
const parallaxUpElements = document.querySelectorAll(".is-parallax-up");

const parallaxUp = elements => {
  elements.forEach(element => {
    let scrolled = window.pageYOffset;
    let y = scrolled * -0.5 + "px";

    if (scrolled < 700) {
      element.style.transform = "translateY(" + y + ")";
    }
  });
};

const parallaxDownElements = document.querySelectorAll(".is-parallax-down");

const parallaxDown = elements => {
  elements.forEach(element => {
    let scrolled = window.pageYOffset;
    let y = scrolled * 0.7 + "px";

    if (scrolled < 300) {
      element.style.transform = "translateY(" + y + ")";
    }
  });
};

const parallaxDownElementsSlow = document.querySelectorAll(".is-parallax-down--slow");

const parallaxDownSlow = elements => {
  elements.forEach(element => {
    let scrolled = window.pageYOffset;
    let y = scrolled * 0.4 + "px";

    if (scrolled < 300) {
      element.style.transform = "translateY(" + y + ")";
    }
  });
};

window.onscroll = () => {
  parallaxDown(parallaxDownElements);
  parallaxDownSlow(parallaxDownElementsSlow);
  parallaxUp(parallaxUpElements);
};

$('a[href^="#"]').on('click', function (e) {
  if ($(this).attr('href') == '#') {
    return false;
  }

  var target = $(this.getAttribute('href'));

  if (target.length) {
    e.preventDefault();
    var headerHeight = $('.js-header').outerHeight() || 0;
    $('html, body').animate({
      scrollTop: target.offset().top - headerHeight
    }, 1000);
  }
});
$(document).ready(function () {
  // Handle form submission with Enter key
  $('.js-site-search-form').keypress(function (e) {
    if (e.which == 13) {
      e.preventDefault();
      $(this).submit();
    }
  }); // Handle click event for navigation search icon

  $('.js-top-bar-search-icon').on('click', function (e) {
    e.preventDefault();
    var $form = $(this).closest('.js-navigation-search');

    if ($form.find('.js-search-trigger').val()) {
      $form.submit();
    }
  }); // Handle click event for content search icon

  $('.js-content-search-icon').on('click', function (e) {
    e.preventDefault();
    var $form = $(this).closest('.js-content-search');

    if ($form.find('.js-search-trigger').val()) {
      $form.submit();
    }
  }); // Handle primary nav search toggle

  $('.js-primary-nav-search-trigger').on('click', function (e) {
    e.preventDefault();
    $('.js-primary-nav-search-form').toggleClass('active');
  }); // Handle search close button

  $('.js-search-close-trigger').on('click', function (e) {
    e.preventDefault();
    $('.js-primary-nav-search-form').toggleClass('active');
  }); // Handle back to menu button

  $('.js-back-to-menu-trigger').on('click', function (e) {
    e.preventDefault();
    $('.js-primary-nav-search-form').removeClass('active');
  });
});
$(".c-m-quote__small__wrapper").each(function () {
  $(this).slick({
    slidesToShow: 1,
    speed: 500,
    prevArrow: false,
    nextArrow: false,
    dots: true,
    fade: true
  });
});
$(".c-m-quote__large__wrapper").each(function () {
  $(this).slick({
    slidesToShow: 1,
    speed: 500,
    prevArrow: false,
    nextArrow: false,
    dots: true,
    infinite: true,
    fade: true
  });
});
$(".c-m-carousel__wrapper").each(function () {
  $(this).slick({
    slidesToShow: 3,
    speed: 500,
    infinite: true,
    appendArrows: $(".c-m-carousel"),
    responsive: [{
      breakpoint: 900,
      settings: {
        slidesToShow: 1
      }
    }]
  });
}); // Interactive Module

if ($('.js-interactive-module').length) {
  $('.js-interactive-module').each(function () {
    let $module = $(this);
    let sliderHeight = $();
    $module.find('.js-interactive-module-slides');
    let $slider = $module.find('.js-interactive-module-slides').slick({
      rows: 0,
      slidesToShow: 1,
      infinite: true,
      // vertical: true,
      // verticalSwiping: true,
      adaptiveHeight: true,
      arrows: false,
      fade: true,
      speed: 0,
      swipe: false,
      // autoplay: true,
      accessibility: false // autoplaySpeed: 5000

    }); // Update buttons on slide changes

    $slider.on('afterChange', function (slick, currentSlide) {
      $module.find('.js-interactive-module-button').removeClass('is-active');
      $module.find('.js-interactive-module-button[data-index="' + $slider.slick('slickCurrentSlide') + '"]').addClass('is-active');
    });
    $module.find('.js-interactive-module-button').on('click', function () {
      let $button = $(this);
      let index = parseInt($button.data('index'));
      $module.find('.js-interactive-module-button').removeClass('is-active');
      $button.addClass('is-active');
      $slider.slick('slickGoTo', index);
    });
  });
}

document.addEventListener('DOMContentLoaded', function () {
  $('.js-styled-select').each((i, el) => {
    $(el).SumoSelect({
      placeholder: '',
      forceCustomRendering: true
    });
  });
  $('.js-multiselect').each((i, el) => {
    $(el).on('sumo:initialized', function (sumo) {
      let $SumoSelect = $(el).parent('.SumoSelect');

      if ($SumoSelect.find('.reset-all').length) {
        // move the reset all button into the MultiControls div
        $SumoSelect.find('.reset-all').appendTo($SumoSelect.find('.MultiControls'));
        $SumoSelect.find('.reset-all label').text('Clear Filters');
      }
    });
    $(el).SumoSelect({
      okCancelInMulti: true,
      placeholder: $(el).data('placeholder'),
      isClickAwayOk: true,
      triggerChangeCombined: true,
      forceCustomRendering: true,
      clearAll: true,
      locale: ['Apply', 'Cancel', 'Select All'],
      csvDispCount: 4,
      renderLi: (li, originalOption) => {
        // manually insert term count onto the li
        li.find('label').append(`<div class="c-styled-select__term-count"> (${li.data('opt').data('count')})</div>`);
        return li;
      }
    });
  });
  $('.js-multiselect').on('change', function () {
    const ajaxUrl = WP.ajaxurl;
    const $container = $('.js-resources-posts-container');
    let $select = $(this);
    let $selectValue = $select.val();
    let data = {
      action: 'cassie_filter_resources',
      paged: "1",
      postType: $container.data('type'),
      taxonomy: $select.attr('name'),
      topics: $selectValue.join('|')
    };
    $.ajax({
      type: 'POST',
      url: ajaxUrl,
      data: data
    }).done(function (returned_data) {
      $('.js-resources-posts-container').remove();
      $(returned_data).insertAfter('.js-container-positioner');
      var currentUrl = $(location).attr("href");

      if (currentUrl.indexOf('/page/') > -1) {
        // if current url has /page/ in it, remove it to revert to the base page url
        currentUrl = currentUrl.substring(0, currentUrl.indexOf('/page/'));
        currentUrl += '/';
      }

      var url = new URL(currentUrl);

      if ($selectValue.length == 0) {
        url.searchParams.delete("topics"); // removing your param
      } else {
        url.searchParams.set("topics", $selectValue.join('|')); // updating your param
      }

      var newUrl = url.href;
      history.pushState(null, null, newUrl);

      if ($('body').find('.js-newsletter-card-form')) {
        const formWrapper = $('body').find('.js-newsletter-card-form')[0];
        var xhttp = new XMLHttpRequest();

        xhttp.onreadystatechange = function () {
          if (this.readyState == 4 && this.status == 200) {
            formWrapper.innerHTML = this.responseText;
            newsletterCardSetup();
          }
        };

        xhttp.open("GET", "/wp-content/themes/cassie/lib/forms/form-newsletter.php", true);
        xhttp.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        xhttp.send();
      }
    });

    if ($('.js-featured-posts-container').length > 0) {
      if (!$selectValue || $selectValue.length === 0) {
        $('.js-featured-posts-container').fadeIn();
      } else {
        $('.js-featured-posts-container').fadeOut();
      }
    }
  });
});
let responsiveMenuOpen = false;
let currentWindowPageYOffset = window.scrollY;
$(document).ready(function () {
  if ($(window).innerWidth() <= 991) {
    $('.sub-menu .sub-menu').each(function () {
      let $currentSubMenu = $(this);
      let height = $(this).parents('.sub-menu').height();
      $currentSubMenu.css('min-height', height + 'px');
    });
  } // Event listener for primary navigation toggle


  $('.js-primary-nav-toggle').on('click', function (e) {
    e.preventDefault();
    let menuToggle = this;
    let responsiveMenu = $('.js-primary-nav-wrapper');
    let responsiveMenuOpen = responsiveMenu.attr('aria-hidden') === 'false';
    let searchToggle = $('.js-primary-nav-search-form');
    searchToggle.removeClass('active');

    if (!responsiveMenuOpen) {
      $(menuToggle).attr('aria-expanded', 'true');
      responsiveMenu.attr('aria-hidden', 'false');
      currentWindowPageYOffset = window.scrollY;
      document.body.style.position = 'fixed';
      document.body.style.top = -currentWindowPageYOffset + 'px';
    } else {
      document.body.style.removeProperty('position');
      document.body.style.removeProperty('top');
      window.scroll({
        top: currentWindowPageYOffset,
        left: 0,
        behavior: "instant"
      });
      $(menuToggle).attr('aria-expanded', 'false');
      responsiveMenu.attr('aria-hidden', 'true');
    }
  }); // Sub Menu Toggle

  $('.js-sub-menu-toggle').on('click', function (e) {
    e.preventDefault();
    let $subMenuToggle = $(this);
    let $searchTrigger = $('.js-primary-nav-search-trigger');
    let $parentMenu = $('.c-primary-nav__menu');
    $('.sub-menu').removeClass('is-active');
    $searchTrigger.hide();

    if (window.innerWidth <= 991) {
      if ($subMenuToggle.attr('aria-expanded') == 'true') {
        $subMenuToggle.attr('aria-expanded', 'false');
      } else {
        $subMenuToggle.attr('aria-expanded', 'true');

        if ($subMenuToggle.hasClass('level-1')) {
          $parentMenu.css('transform', 'translateX(-100vw)');
          let $activeSubMenu = $(this).siblings().children().children('.sub-menu');
          let $activeSubMenuHeight = $activeSubMenu.height() + 60;
          $activeSubMenu.addClass('is-active');
          $parentMenu.css('height', $activeSubMenuHeight);
        } else if ($subMenuToggle.hasClass('level-2')) {
          $parentMenu.css('transform', 'translateX(-200vw)');
          let $activeSubMenu = $(this).siblings('.sub-menu');
          let $activeSubMenuHeight = $activeSubMenu.height() + 60;
          $activeSubMenu.addClass('is-active');
          $parentMenu.css('height', $activeSubMenuHeight);
        }
      }
    }
  }); // Sub Menu Close

  $('.js-sub-menu-close').on('click', function (e) {
    e.preventDefault();
    let $subMenuClose = $(this);
    let $menuItem = $subMenuClose.closest('.menu-item-has-children');
    let $subMenuToggle = $menuItem.children('.js-sub-menu-toggle');
    let $searchTrigger = $('.js-primary-nav-search-trigger');
    let $parentMenu = $('.c-primary-nav__menu');
    $searchTrigger.hide();

    if (window.innerWidth <= 991) {
      $subMenuToggle.attr('aria-expanded', 'false');
      $parentMenu.css('transform', 'translateX(0)');

      if ($subMenuClose.hasClass('level-2')) {
        let $activeSubMenu = $(this).parent().parent('.sub-menu');
        $activeSubMenu.removeClass('is-active');
        $parentMenu.css('height', 'auto');
        $searchTrigger.show();
      } else if ($subMenuClose.hasClass('level-3')) {
        let $activeSubMenu = $(this).parent().parent().parent().parent('.sub-menu');
        let $activeSubMenuHeight = $activeSubMenu.height() + 60;
        $activeSubMenu.removeClass('is-active');
        $parentMenu.css('transform', 'translateX(-100vw)');
        $parentMenu.css('height', $activeSubMenuHeight);
      }
    }
  });

  if ($(window).innerWidth() > 992) {
    // Select all parent menu items
    var parentMenuItems = $('.js-mega-nav .menu-item-has-children'); // Iterate over each parent menu item

    parentMenuItems.each(function () {
      // Select the third sub-menu level for this parent menu item
      var thirdSubMenu = $(this).find('.third-sub-menu-level'); // Add event listener to show the third sub-menu level when hovering

      $(this).on('mouseenter', function () {
        // Make the third sub-menu level visible
        thirdSubMenu.addClass('show');
      }); // Add event listener to hide the third sub-menu level when mouse leaves

      $(this).on('mouseleave', function () {
        // Hide the third sub-menu level
        thirdSubMenu.removeClass('show');
      });
    });

    function checkListItems() {
      var menus = document.querySelectorAll('.third-sub-menu-level');
      menus.forEach(function (menu) {
        var menuItems = menu.querySelectorAll('li');

        if (menuItems.length > 9) {
          menu.classList.add('over-9-items');
        }
      });
    }

    checkListItems();
  }
});
var screenwidth = $(window).width();
$(window).on('resize', function () {
  if (screenwidth !== $(window).width()) {
    if ($(window).innerWidth() <= 991) {
      $('.c-primary-nav__menu').css('height', 'auto');
      $('.sub-menu .sub-menu').each(function () {
        let $currentSubMenu = $(this);
        let height = $(this).parents('.sub-menu').height();
        $currentSubMenu.css('min-height', height + 'px');
      });
    } else {
      $('.c-primary-nav__menu').css('transform', 'initial').css('height', '80px');
      $('.sub-menu .sub-menu').css('min-height', '0px'); // Select all parent menu items

      var parentMenuItems = $('.js-mega-nav .menu-item-has-children'); // Iterate over each parent menu item

      parentMenuItems.each(function () {
        // Select the third sub-menu level for this parent menu item
        var thirdSubMenu = $(this).find('.third-sub-menu-level'); // Add event listener to show the third sub-menu level when hovering

        $(this).on('mouseenter', function () {
          // Make the third sub-menu level visible
          thirdSubMenu.addClass('show');
        }); // Add event listener to hide the third sub-menu level when mouse leaves

        $(this).on('mouseleave', function () {
          // Hide the third sub-menu level
          thirdSubMenu.removeClass('show');
        });
      });

      function checkListItems() {
        var menus = document.querySelectorAll('.third-sub-menu-level');
        menus.forEach(function (menu) {
          var menuItems = menu.querySelectorAll('li');

          if (menuItems.length > 9) {
            menu.classList.add('over-9-items');
          }
        });
      }

      checkListItems();
    }
  }
});

function getQueryParam(param) {
  let urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(param);
}

function saveUTMParametersToLocalStorage() {
  const utmParams = ['utm_campaign', 'utm_medium', 'utm_term', 'utm_content'];
  let hasUTM = false;
  utmParams.forEach(param => {
    const value = getQueryParam(param);

    if (value) {
      localStorage.setItem(param, value);
      hasUTM = true;
    }
  }); // Set defaults if no UTM parameters are present

  if (!hasUTM) {
    utmParams.forEach(param => {
      if (!localStorage.getItem(param)) {
        localStorage.setItem(param, 'NA');
      }
    });
  }
} // Run on every page load to capture UTM parameters if available


saveUTMParametersToLocalStorage();

function populateUTMFields() {
  // Select all instances of the input fields by ID
  const utmCampaignInputs = document.querySelectorAll('#COBJ13CF13');
  const utmMediumInputs = document.querySelectorAll('#COBJ13CF15');
  const utmTermInputs = document.querySelectorAll('#COBJ13CF14');
  const utmContentInputs = document.querySelectorAll('#COBJ13CF12');

  if (utmCampaignInputs.length || utmMediumInputs.length || utmTermInputs.length || utmContentInputs.length) {
    // Get UTM parameters from local storage
    const utmCampaign = localStorage.getItem('utm_campaign') || 'NA';
    const utmMedium = localStorage.getItem('utm_medium') || 'NA';
    const utmTerm = localStorage.getItem('utm_term') || 'NA';
    const utmContent = localStorage.getItem('utm_content') || 'NA'; // Populate hidden fields for all instances

    utmCampaignInputs.forEach(input => {
      if (utmCampaign) {
        input.setAttribute('value', utmCampaign);
      }
    });
    utmMediumInputs.forEach(input => {
      if (utmMedium) {
        input.setAttribute('value', utmMedium);
      }
    });
    utmTermInputs.forEach(input => {
      if (utmTerm) {
        input.setAttribute('value', utmTerm);
      }
    });
    utmContentInputs.forEach(input => {
      if (utmContent) {
        input.setAttribute('value', utmContent);
      }
    });
  }
}